import { OndigoNS } from '../../modules/main.js';

(function ($) {
    'use strict';

    // Class Definition
    OndigoNS.SliderLightbox = function (element) {
        var _instance = this;

        this.$window = $(window);
        this.$slider = $(element);
        this.$sliderOverflow = $('.sliderLightboxOverflow', this.$slider);
        this.$slidesWrapper = $('.sliderLightboxWrapper', this.$slider);
        this.$slides = $('.slide', this.$slider);
        this.$button = $('.sliderButton', this.$slider);
        this.descriptionMaxHeight = 0;

        this.stopSliderAnimation = false;
        this.currentPage = 0;
        this.slideCount = this.$slides.length;
        this.isAnimating = false;
        this.currentMargin = 0;
        this.slideAnimatedWithSwipe = false;
        this.swipingPoint = 75;
        this.activeBreakpoint = this.getActiveBreakPoint();
        this.imageResFactor = this.$slides.eq(0).find('img.'+this.activeBreakpoint).eq(0).data('resolution-factor');

        this.$nextButton = $('.next', this.$slider);
        this.$prevButton = $('.prev', this.$slider);

        this.init = true;

        this.determineActiveBreakpoint();
        this.updateSliderDimensions();

        $('.imageWrapper', this.$slider).height('');

        this.$window.on('load', function () {
            _instance.preloadImage(false, false); // preload the next image
        });

        this.$button.on('click', function (e) {
            _instance.updateCurrentElement(e);
        });

        if (OndigoNS.Utils.hasTouchscreen()) {
            this.$window.on('orientationchange', function () {
                setTimeout(function () {
                    _instance.determineActiveBreakpoint();
                    _instance.updateSliderDimensions();
                }, 100);
            });

            this.$sliderOverflow.swipe({
                swipeStatus: $.proxy(_instance.swipeSlide, this),
                threshold: 10,
                maxTimeThreshold: 2500,
                fingers: 'all',
                allowPageScroll: 'vertical',
                tap:function(event, target) {
                    if($(target).hasClass('video') || $(target).children().hasClass('video')) {
                        $(target).trigger('openLightbox');
                    }
                }
            });
        }
        else {
            this.$window.on('resize', function () {
                setTimeout(function () {
                    _instance.determineActiveBreakpoint();
                    _instance.updateSliderDimensions();
                }, 100);
            });
        }

        _instance.fadeInNavigationalElements();

    };

    OndigoNS.SliderLightbox.prototype = {
        determineActiveBreakpoint: function () {
            var activeBreakpoint,
                $imageToBeLoaded;

            activeBreakpoint = this.getActiveBreakPoint();
            $imageToBeLoaded = $(this.$slides[this.currentPage]).find('img.' + activeBreakpoint);

            if (this.activeBreakpoint !== activeBreakpoint || $imageToBeLoaded.attr('src') === '' || parseInt($imageToBeLoaded.attr('autoload'), 10) === 0) {

                this.activeBreakpoint = activeBreakpoint;

                if (this.init) {
                    this.preloadImage(true, false);
                    this.preloadImage(false, false);

                    this.init = false;
                } else {
                    this.preloadImage(true, false);
                }
            }
        },
        /**
         *
         * @param loadNow (if true load the $activeImage)
         * @param loadPreviousImage (if true load the image previous to $activeImage)
         */
        preloadImage: function (loadNow, loadPreviousImage) {
            var $imageToBeLoaded,
                imageToBeLoadedSource,
                _instance = this;

            if (loadNow) {
                // dot-nav used, need to load current image
                $imageToBeLoaded = $(this.$slides[this.currentPage]).find('img.' + this.activeBreakpoint);
            } else if (loadPreviousImage) {
                $imageToBeLoaded = $(this.$slides[this.currentPage - 1]).find('img.' + this.activeBreakpoint);
            } else {
                $imageToBeLoaded = $(this.$slides[this.currentPage + 1]).find('img.' + this.activeBreakpoint);
            }

            if (($imageToBeLoaded.length && $imageToBeLoaded.attr('src') === '') || parseInt($imageToBeLoaded.attr('autoload'), 10) === 0) {
                if (window.devicePixelRatio > 1) {
                    imageToBeLoadedSource = $imageToBeLoaded.data('retina');
                } else {
                    imageToBeLoadedSource = $imageToBeLoaded.data('image-source');
                }
                if (loadNow) {
                    $imageToBeLoaded[0].onload = function () {
                        _instance.updateSliderDimensions();
                    };
                }

                if($imageToBeLoaded.attr('src') === '' || $imageToBeLoaded.attr('src') !== imageToBeLoadedSource) {
                    var $image = $('<img src="' + imageToBeLoadedSource + '">'),
                        width = $imageToBeLoaded.attr('width') > OndigoNS.Utils.getWindowInnerWidth() ? OndigoNS.Utils.getWindowInnerWidth() : $imageToBeLoaded.attr('width');
                    $imageToBeLoaded.addClass('loading').css('height', (width / $imageToBeLoaded.data('resolution-factor')) + 'px').css('width', width);
                    $image.on('load', function () {
                        $imageToBeLoaded.removeAttr('autoload')
                            .removeAttr('height')
                            .removeClass('loading')
                            .attr('style', '')
                            .hide()
                            .attr('src', imageToBeLoadedSource)
                            .fadeIn('fast', function() {
                                $imageToBeLoaded.removeAttr('style');
                            });
                    });
                }
            }
        },
        fadeInNavigationalElements: function () {
            this.$nextButton.fadeIn(0);
        },
        swipeSlide: function (event, phase, direction, distance) {

            if (this.currentPage < this.slideCount - 1 && direction === 'left' && this.slideAnimatedWithSwipe === false) {

                this.$slidesWrapper.css({
                    'margin-left': this.currentMargin - distance
                });

                if (distance > this.swipingPoint) {

                    this.slideAnimatedWithSwipe = true;

                    this.currentPage++;

                    this.updateActiveSlide();
                    this.animateSlide();
                }
            } else if (this.currentPage > 0 && this.slideCount && direction === 'right' && this.slideAnimatedWithSwipe === false) {

                this.$slidesWrapper.css({
                    'margin-left': this.currentMargin + distance
                });

                if (distance > this.swipingPoint) {

                    this.slideAnimatedWithSwipe = true;

                    this.currentPage--;

                    this.updateActiveSlide();
                    this.animateSlide();
                }
            }

            if (phase === 'end') {
                this.slideAnimatedWithSwipe = false;
                this.animateSlide();
            }
        },
        dotNavigation: function (e) {
            this.currentPage = $(e.target).index();
            this.currentMargin = -this.$slider.width() * this.currentPage;

            this.preloadImage(true, false);
            this.updateActiveSlide();
            this.animateSlide();
        },
        updateSliderDimensions: function () {
            this.currentMargin = -this.$slider.width() * this.currentPage;
            this.imageResFactor = this.$slides.eq(0).find('img.' + this.activeBreakpoint).eq(0).data('resolution-factor');

            var imageMaxHeight = this.$slider.width() / this.imageResFactor,
                _instance = this,
                finalheight,
                textBoxPresent = $('.contentRow', this.$slides).length > 0,
                padding = 20;

            this.descriptionMaxHeight = 0;


            if(textBoxPresent) {
                $.each(this.$slides, function () {
                    var $this = $(this),
                        $slideDescription = $('.contentRow .content', $this),
                        h = $slideDescription.innerHeight() + padding;
                    _instance.descriptionMaxHeight = Math.max(h, _instance.descriptionMaxHeight);
                });
            }


            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                finalheight = this.descriptionMaxHeight + imageMaxHeight;
            }
            else {
                finalheight = imageMaxHeight;
            }

            if (finalheight === 0) {
                return;
            }

            this.$sliderOverflow.css({
                'height': finalheight + 'px'
            });

            this.$slides.width(this.$slider.width());

            this.$slidesWrapper.css({
                'margin-left': this.currentMargin,
                'width': this.$slider.width() * this.slideCount
            });

            this.$slides.height('auto');
            this.$slides.css({'height': finalheight});

        },
        updateCurrentElement: function (e) {
            if (!this.isAnimating) {
                var _instance = this,
                    $currentImage,
                    imageToBeLoadedSource;
                this.isAnimating = true;

                if ($(e.target).hasClass('prev')) {
                    this.currentPage--;

                    this.preloadImage(true, false); // load the previous image
                    this.preloadImage(false, true); // load the image before that one
                } else {
                    this.currentPage++;
                }

                $currentImage = $(this.$slides[this.currentPage]).find('img.' + this.activeBreakpoint);

                if ($currentImage.attr('src') === '') {
                    $currentImage[0].onload = function () {
                        _instance.updateSliderDimensions();
                    };

                    if (window.devicePixelRatio > 1) {
                        imageToBeLoadedSource = $currentImage.data('retina');
                    } else {
                        imageToBeLoadedSource = $currentImage.data('image-source');
                    }
                    $currentImage.attr('src', imageToBeLoadedSource);
                }

                this.updateActiveSlide();
                this.animateSlide();
            }
        },

        getActiveBreakPoint : function () {
            var state = 'desktop';

            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                state = 'smartphone';
            } else if (OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointWide && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                state = 'tablet';
            }

            return state;
        },

        updateActiveSlide: function () {
            this.init = false; //slide needs to be updated, which means we survived the init-phase

            if (this.currentPage === this.slideCount - 1) {
                this.$nextButton.hide();
                this.$prevButton.show();
            } else if (this.currentPage < 1) {
                this.$prevButton.hide();
                this.$nextButton.show();
            } else {
                this.$button.show();
            }

            this.currentMargin = -this.$slider.width() * this.currentPage;

            this.preloadImage(true, false);
        },
        animateSlide: function () {
            var _instance = this;

            this.$slidesWrapper.animate({
                'margin-left': this.currentMargin
            }, 300, function () {
                _instance.isAnimating = false; //allow another animation
            });
        },
        switchImageAndSlider : function () {
            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                this.$sliderOverflow.removeClass('hidden');
            } else {
                this.$sliderOverflow.addClass('hidden');
            }
        }
    };

    // plugin definition
    $.fn.initSliderLightbox = function () {
        return new OndigoNS.SliderLightbox(this);
    };
    $.fn.initSliderLightbox.Constructor = OndigoNS.SliderLightbox;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    var $slider = $('.sliderLightbox');
    if ($slider.length) {
        $.each($slider, function () {
            $(this).initSliderLightbox();
        });
    }
});